import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip,  Box, Grid, Card, CardContent, Typography, Tooltip, Avatar, DialogTitle, DialogContent, Dialog, Button, DialogActions } from '@mui/material';
import axios from 'axios';
import { useEffect, useMemo, useState } from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import LanguageIcon from '@mui/icons-material/Language';


//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_FR } from 'material-react-table/locales/fr';

//Material UI Imports
import { DataGrid } from '@mui/x-data-grid';
import StatCard from '../../components/StatCard';
import { useOrganizationSelect } from '../../context/OrganizationSelectContext';

   

function HistoryLog() {
    const [domains, setDomains] = useState([]);
   const { selectedOrganization } = useOrganizationSelect();
 
    const fetchDomains = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/domain`);
            let filteredData = response.data.filter(
              (item) => !item.name?.toLowerCase().includes('onmicrosoft')
            );
            if (selectedOrganization) {
            filteredData = response.data.filter(
              (item) =>
              item.organizationDetails?.name === selectedOrganization
            );
            }
            setDomains(filteredData.sort((a, b) => new Date(a.domainExpiration) - new Date(b.domainExpiration)));
        } catch (error) {
            console.error('Error fetching organizations:', error);
        }
    };
  
    
  
    useEffect(() => {
        fetchDomains();
    }, [selectedOrganization]);


    const SummaryCard = ({ title, value, color, backgroundColor }) => (
        <Card sx={{ backgroundColor, border: `1px solid ${color}` }}>
        <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography  variant="subtitle2" color="textSecondary">{title}</Typography>&nbsp;
                </Box>
            </Box>
            <Typography variant="h5" sx={{ color }}>
                {value}
            </Typography>
        </CardContent>
    </Card>
      );

    const calculateDomainStats = (domains) => {
        const now = new Date();
        const warningThreshold = new Date();
        warningThreshold.setDate(now.getDate() + 30);

        const expiredDomains = domains.filter(domain => new Date(domain.domainExpiration) < now).length;
        const warningDomains = domains.filter(domain => new Date(domain.domainExpiration) >= now && new Date(domain.domainExpiration) <= warningThreshold).length;

        return { expiredDomains, warningDomains };
    };

    const { expiredDomains, warningDomains } = calculateDomainStats(domains);

     const columns = useMemo(
          () => [
            {
              id: 'domains', //id used to define `group` column
              columns: [
                {
                  accessorFn: (row) => row.name, //accessorFn used to join multiple data into a single cell
                  id: 'domainName', //id is still required when using accessorFn instead of accessorKey
                  header: 'Nom de domaine',
                  Cell: ({ renderedCellValue, row }) => (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem',
                      }}
                    >{renderedCellValue}
                    </Box>
                  ),
                  filterVariant: 'autocomplete',
                },
                  {
                    accessorFn: (row) => {
                      const expirationDate = new Date(row.domainExpiration);
                      return `${expirationDate.toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' })} ${expirationDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`;
                    },
                    id: 'expirationDate', // id is required
                    header: "Date d'expiration",
                    size: 100,
                    Cell: ({ row }) => {
                      const expirationDate = new Date(row.original.domainExpiration);
                      return (
                        <Typography>
                          {expirationDate.toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' })} {expirationDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                        </Typography>
                      );
                    },
                    filterVariant: 'autocomplete',
                  },
                  {
                    accessorFn: (row) => {
                      const expirationDate = new Date(row.domainExpiration);
                      const now = new Date();
                      return Math.ceil((expirationDate - now) / (1000 * 60 * 60 * 24));
                    },
                    id: 'daysRemaining', // id is required
                    header: 'Jours restants',
                    size: 50,
                    Cell: ({ cell }) => (
                      <Typography color="textSecondary">
                        {cell.getValue()} jours
                      </Typography>
                    ),
                    filterVariant: 'range',
                  },
                  {
                    accessorFn: (row) => row.organizationDetails?.name, //accessorFn used to join multiple data into a single cell
                  id: 'organization', //id is still required when using accessorFn instead of accessorKey
                  header: 'Client',
                  size: 250,
                  Cell: ({ renderedCellValue, row }) => (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem',
                      }}
                    >{renderedCellValue}
                    </Box>
                  ),
                  filterVariant: 'autocomplete',
                },
              ]}
          ],
          [],
        );
        
      
        const table = useMaterialReactTable({
    localization: MRT_Localization_FR,
    enableGlobalFilter: true,
    enableColumnFilters: true,

          columns,
          data: domains ? domains : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
          enableColumnFilterModes: true,
          enableColumnOrdering: true,
          enableGrouping: true,
          enableColumnPinning: true,
          enableFacetedValues: true,
          initialState: {
          density: "compact",
          // showColumnFilters: true,
          // showGlobalFilter: true,
          columnPinning: {
            left: ['mrt-row-expand', 'mrt-row-select'],
            right: ['mrt-row-actions'],
          },
          pagination: {
            pageSize: 50,
          }
          },
          paginationDisplayMode: 'pages',
          positionToolbarAlertBanner: 'bottom',
          muiSearchTextFieldProps: {
          size: 'small',
          variant: 'outlined',
          },
          muiPaginationProps: {
          color: 'secondary',
          rowsPerPageOptions: [50, 100, 150],
          shape: 'rounded',
          variant: 'outlined',
          },
        });
      
      
        const [openDialog, setOpenDialog] = useState(false);
        const [selectedDomain, setSelectedDomain] = useState(null);

        const handleRowClick = (params) => {
          setSelectedDomain(params.row);
          setOpenDialog(true);
        };

        const handleCloseDialog = () => {
          setOpenDialog(false);
          setSelectedDomain(null);
        };

        // Helper to get expired domains
        const expiredDomainRows = domains
          .filter(domain => new Date(domain.domainExpiration) < new Date())
          .map((domain, index) => {
            const expirationDate = new Date(domain.domainExpiration);
            const now = new Date();
            const daysRemaining = Math.ceil((expirationDate - now) / (1000 * 60 * 60 * 24));
            return {
              id: index,
              name: domain.name,
              expirationDate: `${expirationDate.toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' })} ${expirationDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`,
              client: domain.organizationDetails?.name || '',
              daysRemaining: `${daysRemaining} jours`,
              raw: domain,
            };
          });

        const [openExpiredDialog, setOpenExpiredDialog] = useState(false);

        const handleOpenExpiredDialog = () => {
          setOpenExpiredDialog(true);
        };

        const handleCloseExpiredDialog = () => {
          setOpenExpiredDialog(false);
        };

        return (
          <Box>
            <Typography variant="h6" my={1}>Nom de domaines</Typography>
            <Box>
              <Grid container spacing={2} marginBlock={2}>
          <Grid size={{ xs: 12, md: 3 }}>
            <Box sx={{ cursor: 'pointer' }}>
              <StatCard
                icon={<Avatar sx={{bgcolor:'#d32f2f'}}><AccessTimeFilledIcon/></Avatar>}
                bgColor={expiredDomains > 0 && '#ffebee'}
                borderColor={expiredDomains > 0 && '1px solid #d32f2f'}
                title={"Domaines expirées"}
                value={expiredDomains}
                showDialog={true}
                dialogTitle="Domaines expirés"
                dialogContent={
                <DataGrid
                  rows={expiredDomainRows}
                  columns={[
                    { field: 'name', headerName: 'Nom de domaine', flex: 1 },
                    { field: 'expirationDate', headerName: "Date d'expiration", flex: 1 },
                    { field: 'client', headerName: 'Client', flex: 1 },
                    { field: 'daysRemaining', headerName: 'Jours restants', flex: 1 },
                  ]}
                  pageSize={10}
                  rowsPerPageOptions={[10, 20, 50]}
                  density="compact"
                />
              }
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <StatCard 
              icon={<Avatar sx={{bgcolor:'#fbc02d'}}><AccessTimeFilledIcon/></Avatar>} 
              bgColor={warningDomains > 0 && '#fffde7'} 
              borderColor={warningDomains > 0 && '1px solid #fbc02d'} 
              title={"Expirations proches"} 
              value={warningDomains} 
              interval={"Sur les 30 prochains jours"}
              showDialog={true}
              dialogTitle="Domaines expirant dans 30 jours"
              dialogContent={
              <DataGrid
          rows={domains
            .filter(domain => {
              const expirationDate = new Date(domain.domainExpiration);
              const now = new Date();
              const warningThreshold = new Date();
              warningThreshold.setDate(now.getDate() + 30);
              return expirationDate >= now && expirationDate <= warningThreshold;
            })
            .map((domain, index) => {
              const expirationDate = new Date(domain.domainExpiration);
              const now = new Date();
              const daysRemaining = Math.ceil((expirationDate - now) / (1000 * 60 * 60 * 24));
              return {
                id: index,
                name: domain.name,
                expirationDate: `${expirationDate.toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' })} ${expirationDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`,
                client: domain.organizationDetails?.name || '',
                daysRemaining: `${daysRemaining} jours`,
                raw: domain,
              };
            })}
          columns={[
            { field: 'name', headerName: 'Nom de domaine', flex: 1 },
            { field: 'expirationDate', headerName: "Date d'expiration", flex: 1 },
            { field: 'client', headerName: 'Client', flex: 1 },
            { field: 'daysRemaining', headerName: 'Jours restants', flex: 1 },
          ]}
          pageSize={5}
          density='compact'
          showToolbar
          rowsPerPageOptions={[5, 10, 20]}
          onRowClick={handleRowClick}
          sx={{ cursor: 'pointer' }}
              />
            }  
            />
          </Grid>
              </Grid>
              <Grid container spacing={2} marginBlock={2}>
          <Grid size={{ xs: 12, md: 3 }}>
            <StatCard icon={<Avatar sx={{bgcolor:'black'}}><LanguageIcon/></Avatar>} title={"Domaines totales"} value={domains.length} />
          </Grid>
              </Grid>
            </Box>    
            {/* <Typography variant="h6" sx={{ }}>Domaines expirant dans les 30 jours</Typography> */}
            {/* <Box component={Paper} sx={{ my: 2, backgroundColor: 'rgb(255, 251, 235)' }} elevation={2}> */}
              {/* <DataGrid
          rows={domains
            .filter(domain => {
              const expirationDate = new Date(domain.domainExpiration);
              const now = new Date();
              const warningThreshold = new Date();
              warningThreshold.setDate(now.getDate() + 30);
              return expirationDate >= now && expirationDate <= warningThreshold;
            })
            .map((domain, index) => {
              const expirationDate = new Date(domain.domainExpiration);
              const now = new Date();
              const daysRemaining = Math.ceil((expirationDate - now) / (1000 * 60 * 60 * 24));
              return {
                id: index,
                name: domain.name,
                expirationDate: `${expirationDate.toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' })} ${expirationDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`,
                client: domain.organizationDetails?.name || '',
                daysRemaining: `${daysRemaining} jours`,
                raw: domain,
              };
            })}
          columns={[
            { field: 'name', headerName: 'Nom de domaine', flex: 1 },
            { field: 'expirationDate', headerName: "Date d'expiration", flex: 1 },
            { field: 'client', headerName: 'Client', flex: 1 },
            { field: 'daysRemaining', headerName: 'Jours restants', flex: 1 },
          ]}
          pageSize={5}
          density='compact'
          rowsPerPageOptions={[5, 10, 20]}
          onRowClick={handleRowClick}
          sx={{ cursor: 'pointer' }}
              /> */}
            {/* </Box> */}
            <Box>
              <Typography variant="h6" sx={{ mb:2 }}>Liste des noms de domaines</Typography>
              <MaterialReactTable table={table} />
            </Box>
            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
              <DialogTitle>Détails du domaine</DialogTitle>
              <DialogContent>
          {selectedDomain && (
            <Box>
              <Typography variant="subtitle1"><b>Nom de domaine:</b> {selectedDomain.name}</Typography>
              <Typography variant="subtitle1"><b>Date d'expiration:</b> {selectedDomain.expirationDate}</Typography>
              <Typography variant="subtitle1"><b>Client:</b> {selectedDomain.client}</Typography>
              <Typography variant="subtitle1"><b>Jours restants:</b> {selectedDomain.daysRemaining}</Typography>
            </Box>
          )}
              </DialogContent>
              <DialogActions>
          <Button onClick={handleCloseDialog}>Fermer</Button>
              </DialogActions>
            </Dialog>
            <Dialog open={openExpiredDialog} onClose={handleCloseExpiredDialog} maxWidth="md" fullWidth>
              <DialogTitle>Domaines expirées</DialogTitle>
              <DialogContent>
          <DataGrid
            rows={expiredDomainRows}
            columns={[
              { field: 'name', headerName: 'Nom de domaine', flex: 1 },
              { field: 'expirationDate', headerName: "Date d'expiration", flex: 1 },
              { field: 'client', headerName: 'Client', flex: 1 },
              { field: 'daysRemaining', headerName: 'Jours restants', flex: 1 },
            ]}
            pageSize={10}
            density='compact'
            rowsPerPageOptions={[10, 20, 50]}
            autoHeight
            sx={{ cursor: 'default', mt: 1 }}
          />
              </DialogContent>
              <DialogActions>
          <Button onClick={handleCloseExpiredDialog}>Fermer</Button>
              </DialogActions>
            </Dialog>
          </Box>
        );



















    return (
        <Box>
            <Grid container spacing={2} marginBlock={2}>
                <Grid size={{ xs: 6, md: 4 }}>
                    <SummaryCard title="Domaines totales" value={domains.length} color="black" />
                </Grid>
                <Grid size={{ xs: 6, md: 4 }}>
                    <Card sx={{ backgroundColor: '#ffebee', border: '1px solid #d32f2f' }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="subtitle2" color="textSecondary">Domaines expirées</Typography>&nbsp;
                                </Box>
                            </Box>
                            <Typography variant="h5" sx={{ color: '#d32f2f' }}>
                                {expiredDomains}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid size={{ xs: 6, md: 4 }}>
                    <SummaryCard title="Expirations proches" value={warningDomains} color="orange" backgroundColor={"rgb(255 251 235)"} />
                </Grid>
            </Grid>

            <TableContainer component={Paper} sx={{ my: 2 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>Domaines expirant dans les 30 jours</Typography>
                <Table size='small'>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: 'rgb(255 251 235)' }}>
                            <TableCell>Nom de domaine</TableCell>
                            <TableCell>Date d'expiration</TableCell>
                            <TableCell>Client</TableCell>
                            <TableCell>Jours restants</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {domains
                            .filter(domain => {
                                const expirationDate = new Date(domain.domainExpiration);
                                const now = new Date();
                                const warningThreshold = new Date();
                                warningThreshold.setDate(now.getDate() + 30);
                                return expirationDate >= now && expirationDate <= warningThreshold;
                            })
                            .map((domain) => {
                                const expirationDate = new Date(domain.domainExpiration);
                                const now = new Date();
                                const daysRemaining = Math.ceil((expirationDate - now) / (1000 * 60 * 60 * 24));
                                return (
                                    <TableRow key={domain._id} sx={{ backgroundColor: 'rgb(255 251 235)' }}>
                                        <TableCell>{domain.name}</TableCell>
                                        <TableCell>{expirationDate.toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' })} {expirationDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</TableCell>
                                        <TableCell>{domain.organizationDetails?.name}</TableCell>
                                        <TableCell>{daysRemaining} jours</TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>

            <TableContainer component={Paper}>
                <Table size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nom de domaine</TableCell>
                            <TableCell>Date d'expiration</TableCell>
                            <TableCell>Client</TableCell>
                            <TableCell>Jours restants</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {domains.map((domain) => {
                            const expirationDate = new Date(domain.domainExpiration);
                            const now = new Date();
                            const daysRemaining = Math.ceil((expirationDate - now) / (1000 * 60 * 60 * 24));
                            return (
                                <TableRow key={domain._id}>
                                    <TableCell>{domain.name}</TableCell>
                                    <TableCell>{expirationDate.toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' })} {expirationDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</TableCell>
                                    <TableCell>{domain.organizationDetails?.name}</TableCell>
                                    <TableCell>{daysRemaining} jours</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default HistoryLog